module.exports = __webpack_public_path__ + "media/images/Self-Evaluation-f35d6ed3000addbe4aeac3aa9752b414.png";